import React from "react";
import EventType from "../../EventType/EventType_";
import { useTranslation } from "react-i18next";

function _EventTypeContainer(props) {
  const eventTypes = props.state;
  const { t } = useTranslation(["home"]);

  return (
    <>
      {Object.keys(eventTypes).length > 0
        ? Object.keys(eventTypes).map((key) => (
            <div
              className="m-2 ms-3 w-auto px-auto"
              key={"eventType-" + key}
              id={`event-type-id-${key}`}
            >
              <EventType key={key} id={key} state={eventTypes[key]} />
            </div>
          ))
        : t("eventTypes.empty")}
    </>
  );
}

export default _EventTypeContainer;
